/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: c3d9d0a0 (Wed Sep 23 18:58:40 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { CashAmount, CashAmountFromJSON, CashAmountToJSON } from './'

/**
 * Represents the amount owed for Semester One.
 * @export
 * @interface TuitionInvoiceSemesterOneDue
 */
export interface TuitionInvoiceSemesterOneDue {
  /**
   *
   * @type Date
   * @memberof TuitionInvoiceSemesterOneDue
   */
  dueDate: Date
  /**
   *
   * @type CashAmount
   * @memberof TuitionInvoiceSemesterOneDue
   */
  amount: CashAmount
}

export function TuitionInvoiceSemesterOneDueFromJSON(
  json: any
): TuitionInvoiceSemesterOneDue {
  return TuitionInvoiceSemesterOneDueFromJSONTyped(json, false)
}

export function TuitionInvoiceSemesterOneDueFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): TuitionInvoiceSemesterOneDue {
  if (json === undefined || json === null) {
    return json
  }
  return {
    dueDate: new Date(json['dueDate']),
    amount: CashAmountFromJSON(json['amount']),
  }
}

export function TuitionInvoiceSemesterOneDueToJSON(
  value?: TuitionInvoiceSemesterOneDue | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    dueDate: value.dueDate.toISOString().substr(0, 10),
    amount: CashAmountToJSON(value.amount),
  }
}
